import { Component } from 'react';
import QuestionIncomingCaller from '../components/QuestionIncomingCaller';
import Success from '../components/Success';

export default class Question extends Component {
  state = {
    step: 1,
    name: '',
    surname: '',
    phone: '',
    email: '',
    language: '',
    isadoctor: '',
    resident_name: '',
    resident_surname: '',

    resident_language: '',
    resident_address: '',
    resident_reason: '',
    referer: '',
  };

  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  render() {
    const { step } = this.state;
    const {
      name,
      surname,
      phone,
      email,
      language,
      isadoctor,
      resident_name,
      resident_surname,
      resident_age,
      resident_gender,
      resident_language,
      resident_address,
      resident_reason,
      referer,
      resident_type,
      residences,
      question,
    } = this.state;
    const values = {
      name,
      surname,
      phone,
      email,
      language,
      isadoctor,
      resident_name,
      resident_surname,
      resident_age,
      resident_gender,
      resident_language,
      resident_address,
      resident_reason,
      referer,
      resident_type,
      residences,
      question,
    };
    document.title = 'Leadtool v3 | Emeis Belgium';

    switch (step) {
      case 1:
        return (
          <QuestionIncomingCaller
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            values={values}
          />
        );
      case 2:
        return (
          <div>
            <Success
              type="Question"
              description="Si vous n’avez pas encore reçu les informations de connexion, vous pouvez demander"
              sentence="New question added"
            />
          </div>
        );
      default:
      // do nothing
    }
  }
}
